import React, { useEffect, useState } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark, faDownload } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import TabsVideos from '../components/TabsVideos';

const PlaylistDetails = () => {
  const [tab, setTab] = useState(null);
  const { tabId } = useParams();


  const downloadUrl = tab && tab.pdfFile ? `${process.env.REACT_APP_API}/download/pdf/${encodeURIComponent(tab.pdfFile)}`: null

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/playlist/${tabId}`)
      .then((response) => {
        setTab(response.data);
      })
      .catch((error) => {
        console.log('Erreur lors de la récupération des détails de la playlist:');
      });
  }, [tabId]);

  const getYouTubeVideoId = (url) => {
    const match = url.match(/(?:youtu\.be\/|youtube\.com(?:\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)))?([^"&?\/\s]{11})/);
    return match?.[1] || null;
  };

  const markAsFavorite = () => {
    const savedVideos = JSON.parse(localStorage.getItem('savedVideos')) || [];
    const isVideoSaved = savedVideos.some(savedVideo => savedVideo._id === tab._id);

    if (!isVideoSaved) {
      savedVideos.push(tab);
      localStorage.setItem('savedVideos', JSON.stringify(savedVideos));
    }
  };

  return (
    <main className="playlist-details">
      <h1 className="heading">Détails de la Playlist</h1>

      {tab && (
        <section className="row">
          <article key={tab._id} className="column">
            <form action="" method="post" className="save-playlist">
              <button type="submit" onClick={(e) => { e.preventDefault(); markAsFavorite(); }}>
                <FontAwesomeIcon icon={faBookmark} /> <span>Mettre la vidéo en favori ({tab.favoritesCount || 0})</span>
              </button>
            </form>

            <section className="thumb">
              <iframe
                width="600"
                height="315"
                src={`https://www.youtube.com/embed/${getYouTubeVideoId(tab.youtubeLink)}`}
                allowFullScreen
                title={tab.title}
              ></iframe>
            </section>
          </article>

          <article className="column">
            <section className="admin">
              <article>
                <h3>{tab.login}</h3>
                <p>{new Date(tab.createdAt).toLocaleDateString()}</p>
              </article>
            </section>

            <section className="details">
              <h3>{tab.artist} - {tab.title}</h3>
              <p>{tab.description}</p>
            </section>
            <a href={downloadUrl} className="purple-btn" download>
              <FontAwesomeIcon icon={faDownload} /> Télécharger la tablature de {tab.artist} - {tab.title}
            </a>

          </article>
        </section>
      )}

      <TabsVideos />
    </main>
  );
};

export default PlaylistDetails;
